const API_BASE_URL = process.env.REACT_APP_API_URL 
const APP_BASE_URL = process.env.REACT_APP_BASE_URL

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/user/login`,
  REGISTER: `${API_BASE_URL}/user/register`,
  FORGOT_PASSWORD: `${API_BASE_URL}/user/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/user/reset-password`,
  VERIFY_EMAIL: `${API_BASE_URL}/auth/verify-email`,
  USER_PROFILE: `${API_BASE_URL}/user/profile`,
  REFRESH_TOKEN: `${API_BASE_URL}/user/refreshToken`,
  USER_lOGOUT: `${API_BASE_URL}/user/logout`,
  USER_lOGOUT_ALL_DEVICES:  `${API_BASE_URL}/user/logout-all-devices`,
  USER_SESSIONS:  `${API_BASE_URL}/user/sessions`,
  USER_CHANGE_PASSWORD:  `${API_BASE_URL}/user/change-password`,
  // User Stats
  USER_STATS:  `${API_BASE_URL}/user/stats`,
  // To Get a List of All Connectors
  GET_ALL_CONNECTORS: `${API_BASE_URL}/sync/connectors`,
  // To Authorise Salesforce
  AUTHORISE_SALESFORCE: `${API_BASE_URL}/salesforce/authorize_salesforce`,
  // To Authorise HubSpot
  AUTHORISE_HUBSPOT: `${API_BASE_URL}/hubspot/authorize_hubspot`,
  // To get the object's field mapping sync/fields?tenantId={{tenant_id}}&connectorId={{connector_id}}
  OBJECT_FIELD_MAPPING: `${API_BASE_URL}/sync/fields`,
  // To save and activate the connector
  CONNECTOR_CONFIG: `${API_BASE_URL}/sync/connector`,
  // To fetch all the Saved Connectors
  SAVED_CONNECTORS: `${API_BASE_URL}/sync/saved-connectors`,
  // To Fetch Connector Fields
  SAVED_CONNECTORS_FIELDS: `${API_BASE_URL}/sync/saved-connectors`,
  // To get Auth status
  GET_SYNC_AUTH_STATUS: `${API_BASE_URL}/sync/getAuthStatus`,

}

export { APP_BASE_URL }

// Export type for API endpoints
export const ApiEndpoints = API_ENDPOINTS
